import {useState, useEffect, useContext} from 'react';
import axios from 'axios';

import {isAuthenticated} from "../auth";
import {CurrentUserContext} from "../contexts/current-user";
import {apiBaseUrl, siteApiBaseUrl} from '../config/public-config';


const useMassFetch = (urls, isBase = false) => {
  const [currentUserState, setCurrentUserState] = useContext(CurrentUserContext);

  const currentSubdomain = currentUserState.currentSite ? currentUserState.currentSite.subdomain : '';
  const baseUrl = isBase ? apiBaseUrl() : siteApiBaseUrl(currentSubdomain);
  const baseOption = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${isAuthenticated().token}`
    }
  };
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);
  const [meta, setMeta] = useState(null);
  const [options, setOptions] = useState({});

  const doMassFetch = (options = {}) => {
    setOptions({
      ...baseOption,
      ...options
    });
    setIsLoading(true);
  };

  useEffect(() => {
    let skipGetResponseAfterDestroy = false;
    if (!isLoading) {
      return;
    }
    setIsLoading(true);
    Promise.all(urls.map(url => { return axios(baseUrl + url, options); }))
      .then((res) => {
        if (!skipGetResponseAfterDestroy) {
          setResponse(res.map(it => it.data));         
          setMeta(res.map(it => it.data.meta));
          setIsLoading(false);
        }
      })
      .catch((err) => {
        if (!skipGetResponseAfterDestroy) {
          if(err.response){
            setError(err.response.map(it => it.data));
          }
          setIsLoading(false);
        }
      });

    return () => {
      skipGetResponseAfterDestroy = true;
    };
  }, [isLoading]);
  
  return [{response, isLoading, error, meta}, doMassFetch];
}

export default useMassFetch;
